import getFetcher from 'api/utils/getFetcher';
import { ApiBaseError } from 'api/utils/shared';
import { useMemo } from 'react';
import useSWR, { type SWRConfiguration } from 'swr';
import type { LegacyUser } from 'types/legacyDashboard';

export interface UsersMeResult {
  success: boolean;
  data: LegacyUser;
}

export interface UsersMeError extends ApiBaseError {}

type UserDetailsSWRConfig = SWRConfiguration<UsersMeResult, UsersMeError>;

interface UseUserDetailsProps {
  canLoad?: boolean;
  config?: UserDetailsSWRConfig;
}

const useUserDetails = ({ canLoad = true, config }: UseUserDetailsProps) => {
  const { data, error, isLoading, mutate, isValidating } = useSWR<UsersMeResult, UsersMeError>(
    canLoad ? `${process.env.VITE_API_ROOT}/users/me` : undefined,
    getFetcher,
    config
  );

  const me: Partial<LegacyUser> = useMemo(() => data?.data ?? {}, [data]);

  return {
    me,
    error,
    isLoading,
    mutate,
    isValidating,
  };
};

export default useUserDetails;
